import { render, staticRenderFns } from "./FiveSenses.vue?vue&type=template&id=312c4c96"
import script from "./FiveSenses.vue?vue&type=script&lang=js"
export * from "./FiveSenses.vue?vue&type=script&lang=js"
import style0 from "./FiveSenses.vue?vue&type=style&index=0&id=312c4c96&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports